import { Directive, HostListener, Input, Renderer2, ElementRef, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[gfContextMenu]'
})
export class ContextMenuDirective implements OnInit {
  @Input('gfContextMenu') menuId: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
    this.closeAllContextMenus();

    const menuElement = this.document.getElementById(this.menuId);
    if (menuElement) {
      this.renderer.setStyle(menuElement, 'display', 'block');
      this.renderer.setStyle(menuElement, 'position', 'fixed');
      this.renderer.setStyle(menuElement, 'z-index', '99999');
      this.renderer.setStyle(menuElement, 'top', `${event.clientY}px`);
      this.renderer.setStyle(menuElement, 'left', `${event.clientX}px`);
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const menuElement = this.document.getElementById(this.menuId);
    if (menuElement) {
      this.renderer.setStyle(menuElement, 'display', 'none');
    }
  }

  closeAllContextMenus() {
    const menus = this.document.querySelectorAll('.gf-context-menu');
    menus.forEach(menu => {
      this.renderer.setStyle(menu, 'display', 'none');
    });
  }
}
